/** String constants for Redux-Saga offer management (maghil-portal style). */

export const OM = {
  // ── Offers ──
  FETCH_OFFER_BY_ID_REQUEST: 'OM_FETCH_OFFER_BY_ID_REQUEST',
  FETCH_OFFER_BY_ID_SUCCESS: 'OM_FETCH_OFFER_BY_ID_SUCCESS',
  FETCH_OFFER_BY_ID_FAILURE: 'OM_FETCH_OFFER_BY_ID_FAILURE',
  OFFERS_SET_EDITING: 'OM_OFFERS_SET_EDITING',
  OFFERS_CLEAR_CACHE: 'OM_OFFERS_CLEAR_CACHE',
  FETCH_OFFERS_REQUEST: 'OM_FETCH_OFFERS_REQUEST',
  FETCH_OFFERS_SUCCESS: 'OM_FETCH_OFFERS_SUCCESS',
  FETCH_OFFERS_FAILURE: 'OM_FETCH_OFFERS_FAILURE',
  CREATE_OFFER_REQUEST: 'OM_CREATE_OFFER_REQUEST',
  CREATE_OFFER_SUCCESS: 'OM_CREATE_OFFER_SUCCESS',
  CREATE_OFFER_FAILURE: 'OM_CREATE_OFFER_FAILURE',
  UPDATE_OFFER_REQUEST: 'OM_UPDATE_OFFER_REQUEST',
  UPDATE_OFFER_SUCCESS: 'OM_UPDATE_OFFER_SUCCESS',
  UPDATE_OFFER_FAILURE: 'OM_UPDATE_OFFER_FAILURE',
  DELETE_OFFER_REQUEST: 'OM_DELETE_OFFER_REQUEST',
  DELETE_OFFER_SUCCESS: 'OM_DELETE_OFFER_SUCCESS',
  DELETE_OFFER_FAILURE: 'OM_DELETE_OFFER_FAILURE',
  BULK_DELETE_OFFERS_REQUEST: 'OM_BULK_DELETE_OFFERS_REQUEST',
  BULK_DELETE_OFFERS_SUCCESS: 'OM_BULK_DELETE_OFFERS_SUCCESS',
  BULK_DELETE_OFFERS_FAILURE: 'OM_BULK_DELETE_OFFERS_FAILURE',
  TOGGLE_OFFER_STATUS_REQUEST: 'OM_TOGGLE_OFFER_STATUS_REQUEST',
  TOGGLE_OFFER_STATUS_SUCCESS: 'OM_TOGGLE_OFFER_STATUS_SUCCESS',
  TOGGLE_OFFER_STATUS_FAILURE: 'OM_TOGGLE_OFFER_STATUS_FAILURE',
  BULK_ARCHIVE_OFFERS_REQUEST: 'OM_BULK_ARCHIVE_OFFERS_REQUEST',
  BULK_ARCHIVE_OFFERS_SUCCESS: 'OM_BULK_ARCHIVE_OFFERS_SUCCESS',
  BULK_ARCHIVE_OFFERS_FAILURE: 'OM_BULK_ARCHIVE_OFFERS_FAILURE',
  OFFERS_ADD: 'OM_OFFERS_ADD',
  OFFERS_UPDATE: 'OM_OFFERS_UPDATE',
  OFFERS_REMOVE: 'OM_OFFERS_REMOVE',

  // ── Promo Codes ──
  PROMO_CODES_SET_EDITING: 'OM_PROMO_CODES_SET_EDITING',
  FETCH_PROMO_CODES_REQUEST: 'OM_FETCH_PROMO_CODES_REQUEST',
  FETCH_PROMO_CODES_SUCCESS: 'OM_FETCH_PROMO_CODES_SUCCESS',
  FETCH_PROMO_CODES_FAILURE: 'OM_FETCH_PROMO_CODES_FAILURE',
  CREATE_PROMO_CODE_REQUEST: 'OM_CREATE_PROMO_CODE_REQUEST',
  CREATE_PROMO_CODE_SUCCESS: 'OM_CREATE_PROMO_CODE_SUCCESS',
  CREATE_PROMO_CODE_FAILURE: 'OM_CREATE_PROMO_CODE_FAILURE',
  UPDATE_PROMO_CODE_REQUEST: 'OM_UPDATE_PROMO_CODE_REQUEST',
  UPDATE_PROMO_CODE_SUCCESS: 'OM_UPDATE_PROMO_CODE_SUCCESS',
  UPDATE_PROMO_CODE_FAILURE: 'OM_UPDATE_PROMO_CODE_FAILURE',
  DELETE_PROMO_CODE_REQUEST: 'OM_DELETE_PROMO_CODE_REQUEST',
  DELETE_PROMO_CODE_SUCCESS: 'OM_DELETE_PROMO_CODE_SUCCESS',
  DELETE_PROMO_CODE_FAILURE: 'OM_DELETE_PROMO_CODE_FAILURE',
  PROMO_CODES_ADD: 'OM_PROMO_CODES_ADD',
  PROMO_CODES_UPDATE: 'OM_PROMO_CODES_UPDATE',
  PROMO_CODES_REMOVE: 'OM_PROMO_CODES_REMOVE',

  // ── Toast ──
  TOAST_ADD: 'OM_TOAST_ADD',
  TOAST_REMOVE: 'OM_TOAST_REMOVE',
} as const;
